import { all, takeLatest } from 'redux-saga/effects'
import service from '../../services/alert.service'
import { actions } from './Alert.state'

function autoClearAlert () {
  setTimeout(() => {
    service.clear()
  }, 7000)
}

export default function * effects () {
  yield all([
    takeLatest(actions.push, autoClearAlert)
  ])
}
